<ion-header class="ion-no-border" style="background: transparent;">
  <ion-toolbar style="--background: transparent; padding-top: env(safe-area-inset-top);">
    <ion-buttons slot="start">
      <ion-button color="dark" (click)="closeModal()" style="margin-top: 10px;">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title style="margin-top: 10px;">
      {{ mode === 'pickup' ? 'Enter Pickup' : (mode === 'destination' ? 'Enter Destination' : 'Plan Trip') }}
    </ion-title>
  </ion-toolbar>

  <div class="search-container">
    <div class="timeline" *ngIf="mode === 'dual'">
      <div class="dot"></div>
      <div class="line"></div>
      <div class="square"></div>
    </div>
    <div class="inputs" [style.padding-left]="mode === 'dual' ? '0' : '16px'">
      <ion-searchbar *ngIf="mode === 'pickup' || mode === 'dual'" animated="true" [(ngModel)]="autocomplete.query2"
        placeholder="Pick Up Location" (ionInput)="updateSearch2()" (ionFocus)="Show()" (ionBlur)="Hide()"
        (ionCancel)="closeSearch()" class="search custom-search" showCancelButton="never"></ion-searchbar>
      <ion-searchbar *ngIf="mode === 'destination' || mode === 'dual'" animated="true" placeholder="Where to?"
        [(ngModel)]="autocomplete.query" (ionInput)="updateSearch()" (ionFocus)="Show()" (ionBlur)="Hide()"
        (ionCancel)="closeSearch()" class="search2 custom-search" showCancelButton="never"></ion-searchbar>
    </div>
  </div>
</ion-header>


<ion-content class='ion-no-padding'>

  <ion-list lines="none">

    <div *ngIf="!skeleton">
      <ion-item *ngFor="let item of skeletOns">
        <ion-label class="ion-margin">
          <h1> <ion-skeleton-text [animated]="true" style="width: 80px"></ion-skeleton-text></h1>
          <p> <ion-skeleton-text [animated]="true" style="width: 130px"></ion-skeleton-text></p>
        </ion-label>
        <ion-thumbnail slot="start">
          <ion-skeleton-text [animated]="true" style="width: 30px; height: 50px;"></ion-skeleton-text>
        </ion-thumbnail>
      </ion-item>
    </div>

    <!-- Saved Places -->
    <ng-container *ngIf="riderProfile?.savedPlaces && autocomplete.query === ''">
      <ion-item button *ngIf="riderProfile.savedPlaces.home" (click)="chooseSavedPlace('home')">
        <ion-icon name="home" slot="start" color="primary"></ion-icon>
        <ion-label class="ion-margin">
          <h1>Home</h1>
          <p>{{ riderProfile.savedPlaces.home.address }}</p>
        </ion-label>
      </ion-item>
      <ion-item button *ngIf="riderProfile.savedPlaces.work" (click)="chooseSavedPlace('work')">
        <ion-icon name="briefcase" slot="start" color="primary"></ion-icon>
        <ion-label class="ion-margin">
          <h1>Work</h1>
          <p>{{ riderProfile.savedPlaces.work.address }}</p>
        </ion-label>
      </ion-item>
    </ng-container>

    <ion-item *ngFor="let item of autocompleteItems" (click)="chooseItem(item)">
      <ion-label class="ion-margin">
        <h1>{{ item.place}}</h1>
        <p>{{item.city}}</p>
      </ion-label>
      <ion-icon name="pin" slot="start"></ion-icon>
    </ion-item>

    <ion-item *ngFor="let item of autocompleteItems2" (click)="chooseItem2(item)">
      <ion-label class="ion-margin">
        <h1>{{ item.place}}</h1>
        <p>{{item.city}}</p>
      </ion-label>
      <ion-icon name="pin" slot="start"></ion-icon>
    </ion-item>

    <!-- <ion-item class='ion-padding' *ngFor="let itme of place">
        <div (click)="choosePlace(itme)">
            {{itme.name}}
            <br />
            <p>{{itme.city}}</p>
        </div> -->

    <!-- <ion-icon color='doom' name="close" item-end (click)="delete(itme)"></ion-icon>
        <ion-icon color='doom' name="pin" item-start></ion-icon>
    </ion-item> -->

    <ion-item *ngIf="!hideImage" style="margin:0 auto;">
      <ion-img src="../../assets/imgs/trip.svg"></ion-img>
    </ion-item>
  </ion-list>


</ion-content>

<ion-footer class="ion-padding" *ngIf="mode === 'dual'">
  <ion-button size="large" shape="round" color="primary" expand='block' (click)="chooseOnMap()">
    <ion-icon slot="icon-only" name="pin"></ion-icon>
    Choose on map
  </ion-button>


</ion-footer>